/**
 * External dependencies
 */
import classnames from 'classnames';

/**
 * WordPress dependencies.
 */
import { Component } from '@wordpress/element';
import { RichText } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';

/**
 * Inner dependencies.
 */
import Inspector from './inspector';
import { updateBlockStyle } from './inline-styles';

class edit extends Component {
	constructor( props ) {
		super( props );
		this.updateBlock = this.updateBlock.bind( this );
	}

	componentDidMount() {
		updateBlockStyle( {}, this.props );
	}

	updateBlock( data ) {
		const { setAttributes } = this.props;
		setAttributes( {
			...data,
		} );

		updateBlockStyle( data, this.props );
	}
	render() {
		const { attributes, setAttributes, isSelected, className } = this.props;

		const {
			text,
			placeholder,
			fontSize,
			style,
		} = attributes;
		return <div className={ classnames( className, {
			[ `has-custom-font-size` ]: fontSize || style,
		} ) }>
			{ isSelected && <Inspector { ...this.props } updateBlock={ this.updateBlock } /> }
			<RichText
				aria-label={ __( 'Button text' ) }
				placeholder={ placeholder || __( 'Add text…' ) }
				value={ text }
				onChange={ ( value ) => {
					setAttributes( { text: value } );
				} }
				allowedFormats={ [ 'core/bold', 'core/italic' ] }
				className={
					classnames(
						// className,
						'gutenify-button-link',
						'wp-block-button__link'
					) }
				rel="noopener noreferrer"
				keepPlaceholderOnFocus
				withoutInteractiveFormatting
				identifier="text"
			/>
		</div>;
	}
}

export default edit;
